import { ReactNode } from 'react';

interface PageTransitionProps {
    children: ReactNode;
    initial?: boolean;
}

export function PageTransition({ children }: PageTransitionProps) {
    return (
        <div className="w-full min-h-screen">
            {children}
        </div>
    );
}

export function SheetTransition({ children, isOpen, onClose }: { children: ReactNode, isOpen: boolean, onClose: () => void }) {
    if (!isOpen) return null;

    return (
        <>
            <div
                onClick={onClose}
                className="fixed inset-0 bg-black/40 z-[60]"
            />
            <div className="fixed inset-x-0 bottom-0 top-10 bg-white dark:bg-[#000D19] rounded-t-[20px] z-[70] shadow-2xl overflow-hidden">
                <div className="w-12 h-1.5 bg-gray-300 rounded-full mx-auto my-3" />
                {children}
            </div>
        </>
    );
}
